<script>
	const alertUtilities = require('utilities/alertUtilities');
	const logger = require('utilities/logger');

	module.exports = {
		props: {
			onSubmit: {
				default: function () {}
			},
			disableSubmit: {
				default: true
			}
		},
		methods: {
			change() {
				this.$el.querySelectorAll('input:not([type="checkbox"]):not([type="radio"]):not(.date-input), select, textarea').forEach(inputEl => {
					inputEl.dispatchEvent(new Event('input'));
					inputEl.dispatchEvent(new Event('change'));
				});
			},
			onSubmitInternal() {
				let el = this.$el;
				let submitButton = $('button[type=submit]', el).get(0);

				this.change();

				let invalidInputs = $('input:invalid, select:invalid', el);
				if (invalidInputs.length) {
					alertUtilities.error('Please fix the errors in the form.');
					return;
				}

				if (this.onSubmit) {
					let prms = this.onSubmit();
					if (prms && prms.catch) {
						if (this.disableSubmit) {
							submitButton.setAttribute('disabled', 'disabled');
						}
						prms
							.finally(() => {
								if (this.disableSubmit) {
									submitButton.removeAttribute('disabled');
								}
							})
							.catch(this.onError);
					}
				}
			},
			onError(err) {
				if (window.readworks.config.rwtesting) {
					logger.info('Validated Form onError', JSON.stringify(err.formError));
				}

				if (err && err.formError) {
					let el = this.$el;
					let formError = err.formError;
					let name = formError.name;
					let message = formError.message;
					let element = $('[name=' + name + ']', el).get(0);
					let submitButton = $('button[type=submit]', el).get(0);

					if (element && element.setCustomValidity) {
						if (window.readworks.config.rwtesting) {
							logger.info('Validated Form onError - setting error', 'element:' + !!element, 'submit:' + !!submitButton);
						}
						element.setCustomValidity(message);
						if (submitButton) {
							if (window.readworks.config.rwtesting) {
								logger.info('Validated Form onError - clicking submit');
							}
							submitButton.click();
						}
					}
				}
			}
		}
	};
</script>
<template>
	<form
		class="validated-form"
		@submit.stop.prevent="onSubmitInternal">
		<slot></slot>
	</form>
</template>
